<template>
    <div id="member-signup">
        <Transition name="toast-transition">
            <div class="toast-notification toast-notification--error" v-if="validationError">
                <div class="toast-notification__icon">
                    <i class="fas fa-exclamation-circle"></i>
                </div>
                <div class="toast-notification__content">
                    <span class="toast-notification__message">{{ validationError }}</span>
                </div>
                <button class="toast-notification__close" @click="dismissError">&times;</button>
            </div>
        </Transition>
        <Transition name="toast-transition">
            <div class="toast-notification toast-notification--error" v-if="otpError">
                <div class="toast-notification__icon">
                    <i class="fas fa-exclamation-circle"></i>
                </div>
                <div class="toast-notification__content">
                    <span class="toast-notification__message">{{ otpError }}</span>
                </div>
                <button class="toast-notification__close" @click="dismissOtpError">&times;</button>
            </div>
        </Transition>
        <div class="d-flex justify-content-center spinner-border primary-text spinner-position form" v-if="page.isLoading"></div>
        <div class="spinner" v-if="page.isLoading"></div>

        <div class="login-wrapper" :style="backgroundStyle">
            <div class="glass-login-card" :class="{ 'form-detail-card': page.cardTitle === 'Form' }">
                <div class="logo-brand mb-2">
                    <img id="logo-brand" :src="corporateLogo" alt="logo" v-if="corporateLogo">
                </div>

                <!-- CHOOSE METHOD STEP -->
        <SignUpMethodChooser
            v-if="page.cardTitle === 'Choose Method' && !isSocialRegistration"
            :ref-param="refParam"
            :merchant-id="member.merchant_id || ''"
            @select-email="chooseEmail"
            @select-google="loginWithGoogle"
            @google-success="handleGoogleRegistrationSuccess"
            @google-error="handleGoogleRegistrationError"
            @apple-success="handleAppleSignUpSuccess"
            @apple-error="handleAppleSignUpError"
        >
            <template #footer>
                <div class="d-flex justify-content-center">
                    <router-link :to="loginLink" class="text-link text-center" style="font-size:13px;">
                        <small>Already have an account? Login</small>
                    </router-link>
                </div>
            </template>
        </SignUpMethodChooser>

                <!-- ENTER EMAIL STEP -->
                <form v-if="page.cardTitle === 'Enter Email' && !isSocialRegistration" @submit.prevent="saveEmail" autocomplete="off">
                    <h4 class="text-center mb-4" style="color: #333333;">Register Account</h4>
                    <p class="text-center mb-4" style="font-size: 14px; color: #6c757d;">Enter your email to get started</p>
                    
                    <div class="custom-input-group mb-4">
                        <input name="email" v-model="member.email" type="email" required placeholder="email" class="glass-input" autocomplete="off"/>
                    </div>
                    <div v-if="validation.email" class="mb-3">
                        <small class="text-danger">{{ validation.email[0] }}</small>
                    </div>

                    <div class="d-flex justify-content-center w-100 mb-4">
                        <button type="submit" class="login-button" :disabled="isNextButtonDisabled">
                            Continue
                        </button>
                    </div>



                    <div class="d-flex justify-content-center mt-1">
                        <router-link :to="loginLink" class="text-link text-center" style="font-size:13px;">
                            <small>Already have an account? Login</small>
                        </router-link>
                    </div>

                    <div class="d-flex justify-content-center mt-3">
                        <span @click="backToChooser" class="text-link" style="font-size:13px; cursor:pointer; text-decoration: underline;">
                            <small>Back to sign up options</small>
                        </span>
                    </div>

                </form>

                <!-- ENTER OTP STEP -->
                <form v-if="page.cardTitle === 'Enter OTP' && !isSocialRegistration" @submit.prevent="submitOTP" autocomplete="off">
                    <h4 class="text-center mb-4" style="color: #333333;">OTP Verification</h4>
                    <p class="text-center mb-2" style="font-size: 13px; color: #6c757d;">
                        *Please check your <strong class="primary-text">{{ member.email }}</strong> mail box to get the OTP code.
                    </p>
                    <div class="text-center mb-4">
                        <span @click="changeEmail" class="change-email-label text-link" style="text-decoration: underline; font-size: 12px; cursor: pointer;">Change Email</span>
                    </div>

                    <div class="d-flex justify-content-center mb-4 mt-2">
                        <o-input-digit 
                            v-model="otp" 
                            placeholder="000000" 
                            :maxlength="6" 
                            class="modern-digit-input"
                            @keyup.enter="submitOTP"
                        />
                    </div>

                    <div class="d-flex justify-content-center align-items-center gap-2 mb-4">
                        <div v-if="showCountdown" style="font-weight: bold; color: #333333; font-size: 14px;">
                            <span>{{ formattedTime }}</span>
                        </div>
                        <span v-if="showRefreshButton" @click="load_state" class="text-link" style="text-decoration: underline; font-size: 14px; cursor: pointer;">
                            Resend OTP
                        </span>
                    </div>

                    <div class="d-flex justify-content-center w-100 mb-4">
                        <button type="submit" class="login-button" :disabled="page.isLoading || !otp">
                            Submit OTP
                        </button>
                    </div>
                </form>

                <!-- FORM REGISTRATION STEP -->
                <form v-if="page.cardTitle === 'Form'" @submit.prevent="saveMember" autocomplete="off" :class="{ 'form-submitting': isSubmitting }" :aria-busy="isSubmitting ? 'true' : 'false'">
                    <h5 class="text-center mb-4" style="font-weight: 700; color: #333333;">FORM REGISTRATION</h5>
                    <div v-if="isSocialRegistration" class="mb-3">
                        <label class="glass-label">{{ isAppleRegistration ? 'Apple Account' : 'Google Account' }}</label>
                        <input :value="member.email" type="email" class="glass-input" readonly />
                        <small class="text-muted d-block mt-1">
                            You will sign in using your {{ isAppleRegistration ? 'Apple' : 'Google' }} account. No password is required.
                        </small>
                    </div>

                    <div class="row align-items-start mb-3">
                        <div class="col-2 pe-1">
                            <label class="glass-label">Title <span class="required">*</span></label>
                            <select v-model="member.title" class="glass-input glass-select" required>
                                <option v-for="t in titles" :key="t.value" :value="t.value" class="text-dark">{{ t.text }}</option>
                            </select>
                        </div>
                        <div class="col-5 px-1">
                            <label class="glass-label">First Name <span class="required">*</span></label>
                            <input name="first_name" v-model="member.first_name" type="text" required placeholder="e.g., John" class="glass-input" autocomplete="new-password"/>
                            <div v-if="validation.first_name"><small class="text-danger">{{ validation.first_name[0] }}</small></div>
                        </div>
                        <div class="col-5 ps-1">
                            <label class="glass-label">Last Name <span class="required">*</span></label>
                            <input name="last_name" v-model="member.last_name" type="text" required placeholder="e.g., Doe" class="glass-input" autocomplete="new-password"/>
                            <div v-if="validation.last_name"><small class="text-danger">{{ validation.last_name[0] }}</small></div>
                        </div>
                    </div>

                    <div v-if="validationName" class="mb-3">
                        <small class="text-danger">{{ validationName }}</small>
                    </div>

                    <div class="row align-items-start mb-3">
                        <div class="col-12 mb-3">
                            <label class="glass-label">Country <span class="required">*</span></label>
                            <select v-model="member.country" class="glass-input glass-select" required>
                                <option v-for="c in countries" :key="c.value" :value="c.value" class="text-dark">{{ c.text }}</option>
                            </select>
                        </div>
                        <div class="col-12">
                            <label class="glass-label">Phone <span class="required">*</span></label>
                            <div class="d-flex flex-row">
                                <input v-if="!unknownCountry" name="countryCode" v-model="countryCode" type="text" readonly disabled class="glass-input code-input me-2 text-center" style="width: 25%; padding-left: 5px; padding-right: 5px;" />
                                <input name="phone" v-model="member.phone" type="tel" required minlength="4" maxlength="15" placeholder="e.g., 81234567890" class="glass-input" autocomplete="off" style="width: 100%;" @input="member.phone = member.phone.replace(/[^0-9]/g, '')"/>
                            </div>
                            <div v-if="validation.phone"><small class="text-danger">{{ validation.phone[0] }}</small></div>
                            <div v-if="phoneValidationError"><small class="text-danger">{{ phoneValidationError }}</small></div>
                        </div>
                    </div>

                    <div class="mb-3" v-if="!isSocialRegistration">
                        <label class="glass-label">Password <span class="required">*</span> <i class="fas fa-info-circle ms-1" title="Password at least 6 characters, include uppercase, lowercase, numbers, and special characters" style="font-size: 13px; cursor: help; color: #6c757d;"></i></label>
                        <div class="position-relative">
                            <input name="password" v-model="member.password" :type="showPassword ? 'text' : 'password'" required placeholder="••••••••" class="glass-input" style="padding-right: 40px;" autocomplete="new-password"/>
                            <i class="fas" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" @click="showPassword = !showPassword"
                                style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); cursor: pointer; color: #6c757d;"></i>
                        </div>
                        <div v-if="validation.password"><small class="text-danger">{{ validation.password[0] }}</small></div>
                        <div v-if="passwordValidationError"><small class="text-danger d-block mt-1">{{ passwordValidationError }}</small></div>
                    </div>

                    <div class="mb-3" v-if="!isSocialRegistration">
                        <label class="glass-label">Retype Password <span class="required">*</span></label>
                        <div class="position-relative">
                            <input name="retype_password" v-model="retypePassword.retypePassword" :type="showRetypePassword ? 'text' : 'password'" required placeholder="••••••••" class="glass-input" style="padding-right: 40px;" autocomplete="new-password"/>
                            <i class="fas" :class="showRetypePassword ? 'fa-eye-slash' : 'fa-eye'" @click="showRetypePassword = !showRetypePassword"
                                style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); cursor: pointer; color: #6c757d;"></i>
                        </div>
                        <div v-if="!isPasswordMatch"><small class="text-danger">{{ validationPassword }}</small></div>
                    </div>

                    <div class="mb-5">
                        <label class="glass-label">Referral Code (Optional)</label>
                        <input name="referral_code" v-model="member.referral_code" type="text" placeholder="Enter referral code if you have one" class="glass-input" autocomplete="off"/>
                        <small v-if="member.referral_code" class="text-success d-block mt-1">
                          ✓ Referral code will be applied to your registration
                        </small>
                    </div>

                    <div class="d-flex justify-content-center w-100 mt-2">
                        <button type="submit" class="login-button w-100" :class="{ 'is-loading': isSubmitting }" :disabled="isRegisterButtonDisabled || isSubmitting">
                            <span v-if="isSubmitting" class="btn-spinner" aria-hidden="true"></span>
                            <span>{{ submitLabel }}</span>
                        </button>
                    </div>
                    <Transition name="fade-hint">
                        <p v-if="isSubmitting && isSlowSubmit" class="submit-hint" role="status" aria-live="polite">
                            This is taking longer than usual. Please keep the app open.
                        </p>
                    </Transition>
                </form>
            </div>
            
            <div class="login-footer">
                Copyright © PT. Omni Hotelier Internasional {{ currentYear }}
            </div>
        </div>
    </div>
</template>

<script>

import { reactive, ref, computed } from '@vue/reactivity';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { onMounted, onUnmounted } from '@vue/runtime-core';
import { watch, nextTick } from 'vue';
import { Capacitor } from '@capacitor/core';
import api from '@/helpers/api';
import { OInputDigit } from '@/components/OmnihControl';
import storageService from '@/services/storageService';
import { pushNotificationHandler } from '@/mobile/plugins/pushNotification';
import SignUpMethodChooser from '@/components/SignUpMethodChooser.vue';
import { clearRefContext, preserveRefForSso } from '@/services/refParameter';


export default {
    components: {
        OInputDigit,
        SignUpMethodChooser,        
    },
    setup() {
        const route = useRoute();
        const store = useStore();
        const router = useRouter();
        const isNativePlatform = computed(() => Capacitor.isNativePlatform());
        const googleRegistrationTokenFromRoute = typeof route.query.google_registration_token === 'string'
            ? route.query.google_registration_token
            : '';
        const appleRegistrationTokenFromRoute = typeof route.query.apple_registration_token === 'string'
            ? route.query.apple_registration_token
            : '';

        // Parameter `ref` identifies an external integration. It may enable
        // automatic social registration; email OTP registration always uses the form.
        const refParam = computed(() => (typeof route.query.ref === 'string' ? route.query.ref : ''));
        const hasValidRef = computed(() => {
            if (!refParam.value) return false;
            try {
                if (!/^[A-Za-z0-9+/]+={0,2}$/.test(refParam.value)) return false;
                const decodedRef = atob(refParam.value).trim();
                if (!decodedRef) return false;
                const url = new URL(/^https?:\/\//i.test(decodedRef) ? decodedRef : `https://${decodedRef}`);
                return ['http:', 'https:'].includes(url.protocol) && Boolean(url.hostname);
            } catch (e) {
                return false;
            }
        });

        const titles = ref([
            { value: 'Mr.', text: 'Mr.' },
            { value: 'Mrs.', text: 'Mrs.' },
            { value: 'Miss', text: 'Miss' }
        ]);

        const socialTokenFromRoute = !!(googleRegistrationTokenFromRoute || appleRegistrationTokenFromRoute);
        const autoRegisterOnLoad = socialTokenFromRoute && hasValidRef.value;
        const page = reactive({
            isLoading: autoRegisterOnLoad,
            cardTitle: autoRegisterOnLoad ? 'Auto Register' : (socialTokenFromRoute ? 'Form' : 'Choose Method')
        });

        const loginBackground = ref('');
        const corporateLogo = ref('');
        const currentYear = new Date().getFullYear();
        const isNewAuthActive = ref(false);

        const loginLink = computed(() => {
            const merchant_id = member.merchant_id || new URLSearchParams(window.location.search).get('merchant_id');
            const query = merchant_id ? { merchant_id } : {};
            if (hasValidRef.value) query.ref = refParam.value;
            
            // For native platform, always use the standard Login route
            if (window.Capacitor?.isNativePlatform()) {
                return { name: 'Login', query };
            }
            
            if (!isNewAuthActive.value) {
                return { name: 'Login', query };
            }

            const backUrl = window.history.state?.back || '';
            
            // backUrl (browser history)
            if (backUrl.includes('/backoffice/login')) {
                return { name: 'BackofficeLogin', query };
            } else if (backUrl.includes('/member/login')) {
                return { name: 'MemberLogin', query };
            }
            // Fallback: check auth_origin for sign-up flow from new auth pages
            const authOrigin = localStorage.getItem('auth_origin');
            if (authOrigin === 'backoffice') {
                return { name: 'BackofficeLogin', query };
            } else if (authOrigin === 'member') {
                return { name: 'MemberLogin', query };
            }
            
            return { name: 'Login', query };
        });

        const backgroundStyle = computed(() => ({
            backgroundImage: loginBackground.value ? `url(${loginBackground.value})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        }));
        const isIosPlatform = computed(() => Capacitor.getPlatform() === 'ios');

        const checkImage = (url) => {
            return new Promise((resolve) => {
                const img = new window.Image();
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
                img.src = url;
            });
        };

        const isRegistered = ref(false);
        const otpError = ref('');
        const validationError = ref('');
        const validation = ref({});

        // Submit feedback state (registration button)
        const isSubmitting = ref(false);
        const submitStep = ref('idle'); // 'idle' | 'registering' | 'signing_in'
        const isSlowSubmit = ref(false);
        let slowSubmitTimer = null;

        const submitLabel = computed(() => {
            if (!isSubmitting.value) return 'Register';
            return submitStep.value === 'signing_in' ? 'Signing you in…' : 'Creating account…';
        });

        const startSubmit = () => {
            isSubmitting.value = true;
            submitStep.value = 'registering';
            isSlowSubmit.value = false;
            validationError.value = '';
            validation.value = {};
            // Dismiss the soft keyboard (Android) so the progress state is visible
            if (document.activeElement && typeof document.activeElement.blur === 'function') {
                document.activeElement.blur();
            }
            clearTimeout(slowSubmitTimer);
            slowSubmitTimer = setTimeout(() => { isSlowSubmit.value = true; }, 8000);
        };

        const endSubmit = (message) => {
            clearTimeout(slowSubmitTimer);
            isSubmitting.value = false;
            submitStep.value = 'idle';
            isSlowSubmit.value = false;
            if (message) validationError.value = message;
        };

        const handleRegisterError = (err) => {
            console.error(err);
            const raw = err?.response?.data?.error;

            if (err?.isAxiosError && !err.response) {
                endSubmit('Network error. Please check your connection and try again.');
                return;
            }

            try {
                const parsed = JSON.parse(raw);
                if (parsed && typeof parsed === 'object') {
                    validation.value = parsed;
                    endSubmit('Please check the highlighted fields.');
                    nextTick(() => {
                        const firstError = document.querySelector('#member-signup form .text-danger');
                        if (firstError && firstError.scrollIntoView) {
                            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    });
                    return;
                }
            } catch (e) {
                // not a JSON validation payload, fall through
            }

            endSubmit(typeof raw === 'string' && raw ? raw : 'Registration failed. Please try again.');
        };
        const validationName = ref('');
        const passwordValidationError = ref('');
        const phoneValidationError = ref('');
        const showRefreshButton = ref(false);
        const showCountdown = ref(false);
        const countdownMinutes = ref(1);
        const countdownSeconds = ref(0);
        let countdownInterval = null;
        
        const formattedTime = computed(() => {
            const minutes = countdownMinutes.value;
            const seconds = countdownSeconds.value < 10 ? `0${countdownSeconds.value}` : countdownSeconds.value;
            return `${minutes}:${seconds}`;
        });

        const retypePassword = reactive({
            retypePassword: "",
        })
       
        // Fix merchant_id jika null atau undefined
        const initialMerchantId = route.params.merchant_id || route.query.merchant_id || '';
        const validationPassword = ref('Passwords do not match');
        const showPassword = ref(false);
        const showRetypePassword = ref(false);
        
        const member = reactive({
            merchant_id: initialMerchantId,
            title: "Mr.",
            first_name: route.query.google_first_name || route.query.apple_first_name || "",
            last_name: route.query.google_last_name || route.query.apple_last_name || "",
            email: route.query.google_email || route.query.apple_email || "",
            phone: "",
            password: "",
            country: 101,
            referral_code: "",
            google_registration_token: googleRegistrationTokenFromRoute,
            apple_registration_token: appleRegistrationTokenFromRoute
        });

        const isGoogleRegistration = computed(() => !!member.google_registration_token);
        const isAppleRegistration = computed(() => !!member.apple_registration_token);
        const isSocialRegistration = computed(() => isGoogleRegistration.value || isAppleRegistration.value);

        // Penyelesaian login sosial (Google & Apple) - satu jalur untuk keduanya, sehingga
        // Google ikut tersimpan ke native storage (auto-login) persis seperti Apple.
        const finalizeSocialLogin = async ({ provider, token, user, tenantDomain, level }) => {
            const userData = { ...user };
            if (!userData.first_name && !userData.last_name && userData.name) {
                const parts = userData.name.trim().split(' ');
                userData.first_name = parts[0] || '';
                userData.last_name = parts.slice(1).join(' ') || '';
            }
            if (!userData.title) userData.title = '';

            try {
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(userData));
                localStorage.setItem('level', level || (userData.member ? 'member' : 'admin'));
                localStorage.setItem('member', JSON.stringify(userData.member || true));
                localStorage.setItem('corporate_id', userData.corporate_id || '');
                if (tenantDomain) {
                    localStorage.setItem('tenant_domain', tenantDomain);
                }
                if (Capacitor.isNativePlatform()) {
                    await storageService.syncToNative();
                }
            } catch (storageError) {
                // Non-blocking
            }

            clearRefContext();
            localStorage.removeItem('campaign_referral_code');

            store.commit('Auth/set_login_provider', provider);
            store.commit('Auth/auth_success', { token, user: userData });
            await store.dispatch('Auth/auth_check');

            if (Capacitor.isNativePlatform()) {
                try {
                    await pushNotificationHandler.registerDevice();
                } catch (pushError) {
                    console.error('[MemberSignUp] Push notification registration failed:', pushError);
                }
            }

            await router.replace({ name: 'client_dashboard' }).catch(() => {
                window.location.href = '/client/dashboard';
            });
        };

        // Setelah register lewat form (Google / Apple): response register berisi auth_token
        const completeSocialSignIn = async (provider, token, gUser) => {
            await finalizeSocialLogin({
                provider,
                token,
                level: 'member',
                user: {
                    id: gUser.id,
                    email: gUser.email,
                    title: gUser.title,
                    first_name: gUser.first_name,
                    last_name: gUser.last_name,
                    corporate_id: gUser.corporate_id,
                    level: 'member',
                },
            });
        };
        
        // Debug merchant_id value
        console.log('[DEBUG] Initial merchant_id from route:', route.params.merchant_id);
        console.log('[DEBUG] Corrected merchant_id:', member.merchant_id);
        console.log('[DEBUG] Expected merchant_id from env:', process.env.VUE_APP_MERCHANTID_APP || 'fallback');
        
        // Watch for changes in route params
        watch(() => route.params.merchant_id, (newMerchantId) => {
            console.log('[DEBUG] Route merchant_id changed to:', newMerchantId);
            member.merchant_id = newMerchantId || route.query.merchant_id || '';
        });
        
        onMounted(async () => {
            console.log('token', member.google_registration_token, page.cardTitle)
            if (!member.merchant_id || member.merchant_id === 'null' || member.merchant_id === 'undefined') {
                try {
                    const context = await store.dispatch('Member/member_default_context');
                    member.merchant_id = context.data?.data?.merchant_id || '';
                    if (!member.merchant_id) {
                        throw new Error('No merchant is available for member registration.');
                    }
                } catch (error) {
                    validationError.value = error.message || 'Unable to determine a merchant for registration.';
                }
            }

            if (socialTokenFromRoute) {
                const fromApple = !!appleRegistrationTokenFromRoute;
                member.google_registration_token = googleRegistrationTokenFromRoute;
                member.apple_registration_token = appleRegistrationTokenFromRoute;
                member.email = (fromApple ? route.query.apple_email : route.query.google_email) || '';
                member.first_name = (fromApple ? route.query.apple_first_name : route.query.google_first_name) || '';
                member.last_name = (fromApple ? route.query.apple_last_name : route.query.google_last_name) || '';

                // Bersihkan token dari address bar TANPA memicu vue-router (agar komponen tidak di-remount)
                const safeQuery = new URLSearchParams(window.location.search);
                [
                    'google_registration_token', 'google_email', 'google_first_name', 'google_last_name',
                    'apple_registration_token', 'apple_email', 'apple_first_name', 'apple_last_name',
                ].forEach((k) => safeQuery.delete(k));
                const qs = safeQuery.toString();
                window.history.replaceState(
                    window.history.state,
                    '',
                    window.location.pathname + (qs ? `?${qs}` : '')
                );

                if (hasValidRef.value) {
                    // ref terisi: tanpa form, akun dibuat otomatis dengan data default
                    await autoRegister();
                } else {
                    page.cardTitle = 'Form';
                }
            }
        });

        const countries = ref([]);
        const countriesData = ref([]); // Store full country data with phone_code
        const countryCode = ref('');
        const unknownCountry = ref(false);

        const otp = ref('');
        const newEmailInput = ref('');
        const memberData = ref(null);

        onMounted(() => {
            const urlParams = new URLSearchParams(window.location.search);
            const referralFromUrl = urlParams.get('referral');
            const referralFromStorage = localStorage.getItem('campaign_referral_code');
            
            if (referralFromUrl) {
                member.referral_code = referralFromUrl;
                localStorage.setItem('campaign_referral_code', referralFromUrl);
            } else if (referralFromStorage) {
                member.referral_code = referralFromStorage;
            }
            if (hasValidRef.value) {
                localStorage.setItem('register_ref_param', refParam.value);
            } else {
                clearRefContext();
            }

            loginBackground.value = localStorage.getItem('loginBackground') || '/img/temporary-login.png';
            corporateLogo.value = localStorage.getItem('corporateLogo') || '/img/icons/Color_Alternate-1024x381.png';

            api.request('get', `/api/public/corporate-id`)
                .then(async (response) => {
                    const corporateId = response.data.data;
                    const s3Url = process.env.VUE_APP_S3_BUCKET;
                    
                    const bgUrl = `${s3Url}user_assets/${corporateId}/loginBackground.png`;
                    const bgExists = await checkImage(bgUrl);
                    if (bgExists) {
                        loginBackground.value = bgUrl;
                    }

                    const extensions = ['png', 'jpg', 'jpeg', 'webp'];
                    for (const ext of extensions) {
                        const logoUrl = `${s3Url}user_assets/${corporateId}/corporateLogo.${ext}`;
                        if (await checkImage(logoUrl)) {
                            corporateLogo.value = logoUrl;
                            break;
                        }
                    }
                })
                .catch(error => {
                    console.error('Failed request', error);
                });

            // Check new_auth flag status
            api.request('get', '/api/public/auth-module-status')
                .then((response) => {
                    isNewAuthActive.value = response.data?.data?.enabled === true;
                })
                .catch(() => {
                    isNewAuthActive.value = false;
                });
        });

        const chooseEmail = () => {
            page.cardTitle = 'Enter Email';
        };

        const backToChooser = () => {
            member.email = '';
            page.cardTitle = 'Choose Method';
        };

        const saveEmail = () => {
            if (member.google_registration_token) {
                page.cardTitle = 'Form';
                return;
            }

            // Validate email before sending
            if (!member.email || member.email.trim() === '') {
                validationError.value = 'Please enter a valid email address';
                return;
            }
            
            // Validate email format
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(member.email)) {
                validationError.value = 'Please enter a valid email format';
                return;
            }
            
            const data = {...member};
            console.log('[DEBUG] Sending OTP request with data:', data);
                
            page.isLoading = true;

            requestOTP(data).then(() => {
                isRegistered.value = true;
                memberData.value = data;
                page.cardTitle = 'Enter OTP';

                startCountdown();
            }).catch(() => {
                // console.log(err);
                page.isLoading = false;

            }).finally(() => {
                page.isLoading = false;
            });
        };

        const loginWithGoogle = () => {
            const referralCode = member.referral_code || localStorage.getItem('campaign_referral_code');
            const state = {};
            if (referralCode) state.referral_code = referralCode;
            if (route.query.ref) state.ref = route.query.ref;
            preserveRefForSso(refParam.value);

            store.dispatch('Auth/googleLogin', {
                merchant_id: member.merchant_id,
                source: 'member_portal',
                state: btoa(JSON.stringify(state)),
            });
        };

        const handleGoogleRegistrationSuccess = async (authData) => {
            console.log('google result', JSON.stringify(authData));
            const result = authData.data || authData;
            try {
                if (result.registration_required) {
                    member.google_registration_token = result.registration_token;
                    member.email = result.profile.email;
                    member.first_name = result.profile.first_name || member.first_name;
                    member.last_name = result.profile.last_name || member.last_name;
                    if (hasValidRef.value) {
                        // ref terisi: tanpa form, akun dibuat otomatis dengan data default
                        await autoRegister();
                        return;
                    }
                    page.cardTitle = 'Form';
                    return;
                }

                const user = result.user;
                if (!result.token || !user) {
                    throw new Error('Google authentication response is incomplete.');
                }

                await finalizeSocialLogin({
                    provider: 'google',
                    token: result.token,
                    user,
                    tenantDomain: result.tenant_domain,
                });
            } catch (error) {
                validationError.value = error.message || 'Google sign-in could not be completed.';
            }
        };

        const handleGoogleRegistrationError = (error) => {
            const code = error.code || error.message || '';
            if (code === 'AUTH.LOGIN.FAILED.MEMBER.LOGIN.WITH.SOCIALITE') {
                validationError.value = 'This email is already registered with email and password. Please log in using your email and password.';
            } else {
                validationError.value = error.message || 'Google sign-in failed. Please try again.';
            }
        };

        const saveMember = () => {
            // Guard against double tap / double Enter while a request is running
            if (isSubmitting.value) return;

            if (!isSocialRegistration.value && member.password != retypePassword.retypePassword){
                return;
            } else {
                startSubmit();
                store.dispatch('RegisterOption/read_register_option', member.merchant_id)
                .then((registerOption) => {
                    const data = {...member};
                    data.phone = countryCode.value + data.phone;

                    if (isSocialRegistration.value) {
                        delete data.password;
                    }

                    const now = new Date();
                    const padZero = (num) => String(num).padStart(2, '0');

                    const formattedDate = `${now.getFullYear()}-${padZero(now.getMonth() + 1)}-${padZero(now.getDate())} ` +
                                        `${padZero(now.getHours())}:${padZero(now.getMinutes())}:${padZero(now.getSeconds())}`;

                    data.email_verified_at = formattedDate;

                    let registerResponse;
                    const isNativeApp = window.Capacitor?.isNativePlatform() === true;
                    // Mark platform so backend assigns correct campaign (Mobile App Login)
                    if (isNativeApp) {
                        data.platform = 'native';
                    }

                    store.dispatch('Member/register', { data }).then((res) => {
                        registerResponse = res;
                        
                        // Clear referral code from localStorage after successful registration
                        localStorage.removeItem('campaign_referral_code');

                        // Account is created; the next step is signing the member in
                        if (registerOption.data.data.original[0] == 1) {
                            submitStep.value = 'signing_in';
                        }
                        
                        if (isSocialRegistration.value && registerOption.data.data.original[0] == 1) {
                            const gUser = res?.data?.data?.[0];
                            if (gUser?.auth_token) {
                                completeSocialSignIn(isAppleRegistration.value ? 'apple' : 'google', gUser.auth_token, gUser).catch((e) => {
                                    endSubmit(e.message || 'Sign-in could not be completed.');
                                });
                                return;
                            }
                        }


                        const loginDatas = {
                            email: data.email,
                            password: data.password,
                            merchant_id: data.merchant_id,
                            ref: hasValidRef.value ? refParam.value : undefined,
                            // Include platform so auth.js login() won't set web_temp_access on native
                            platform: isNativeApp ? 'native' : 'web',
                        };
                        const fromMemberLogin = localStorage.getItem('member_login_origin') === 'true';
                        const loginAction = fromMemberLogin ? 'Auth/memberLogin' : 'Auth/login';

                        if (registerOption.data.data.original[0] == 1) {
                            localStorage.removeItem('member_login_origin');
                            if (fromMemberLogin && hasValidRef.value && !isNativeApp && data.merchant_id) {
                                loginDatas.type = 'web_temp_access';
                            }

                            if ('redirect' in route.query) {
                                // Skenario 1: Otomatis ke Book Page
                                store.dispatch(loginAction, loginDatas)
                                .then(async (res) => {
                                    if (await continueRegistrationLogin(res)) return;
                                    if (res?.type == "web_temp_access" && res?.url !== null) {        
                                        const url = `${res.url}?member_token=${res.token}`;
                                        
                                        // Simpan semua key dan value dari res ke dalam sebuah konstanta
                                        const resData = {};
                                        for (const key in res) {
                                            if (Object.prototype.hasOwnProperty.call(res, key) && key !== 'url') {
                                                resData[key] = res[key];
                                                // Simpan key dan value ke local storage
                                                localStorage.setItem(key, key === 'token' ? res[key] : JSON.stringify(res[key]));
                                            }
                                        }
                                        try {
                                            fetch(url)
                                            .then(response => {
                                                if (!response.ok) {
                                                    throw new Error('Network response was not ok');
                                                }
                                                return response.json();
                                            })
                                            .then((resp) => {
                                                let rawRedirectUrl = resp?.redirectUrl || '';
                                                if (rawRedirectUrl && !rawRedirectUrl.startsWith('http://') && !rawRedirectUrl.startsWith('https://')) {
                                                    rawRedirectUrl = 'http://' + rawRedirectUrl;
                                                }
                                                if (!rawRedirectUrl) {
                                                    console.error('[SignUp] No valid redirectUrl in response', resp);
                                                    endSubmit('Your account was created, but we could not continue. Please log in.');
                                                    return;
                                                }
                                                const redirectUrl = new URL(rawRedirectUrl);
                                                redirectUrl.searchParams.append('username', resData.username);
                                                redirectUrl.searchParams.append('token', resData.token);
                                                redirectUrl.searchParams.append('tierId', resData.tierId);
                                                redirectUrl.searchParams.append('tier_name', resData.tier_name);
                                                redirectUrl.searchParams.append('point', resData.point);
                                                redirectUrl.searchParams.append('voucher', resData.voucher);
                                                redirectUrl.searchParams.append('media', resData.media);

                                                window.location.href = redirectUrl.toString();
                                            })
                                            .catch((fetchError) => {
                                                console.error('[SignUp] Redirect fetch failed', fetchError);
                                                endSubmit('Your account was created, but we could not continue. Please log in.');
                                            });
                                        } catch (error) {
                                            console.log('error',error);
                                            endSubmit('Your account was created, but we could not continue. Please log in.');
                                        }                    
                                        return;
                                    } else {
                                        router.push({ name: 'client_dashboard' });
                                    }
                                })
                                .catch((err) => {
                                    console.log(err);
                                    endSubmit('Your account was created, but automatic sign-in failed. Please log in.');
                                });
                            } else if ('autologin' in route.query) {
                                // Skenario 3: Arahkan ke halaman dashboard
                                store.dispatch(loginAction, loginDatas)
                                .then(async (res) => {
                                    if (await continueRegistrationLogin(res)) return;
                                    for (const key in res) {
                                        if (Object.prototype.hasOwnProperty.call(res, key) && key !== 'url') {
                                            localStorage.setItem(key, key === 'token' ? res[key] : JSON.stringify(res[key]));
                                        }
                                    }
                                    router.push({ name: 'client_dashboard' });
                                })
                                .catch((err) => {
                                    console.error(err);
                                    endSubmit('Your account was created, but automatic sign-in failed. Please log in.');
                                });
                            }else {
                                const responseData = registerResponse.data.data[0];
                                
                                const registerRef = localStorage.getItem('register_ref_param');
                                if (registerRef) {
                                    localStorage.removeItem('register_ref_param');
                                }

                                store.dispatch(loginAction, loginDatas)
                                .then(async (res) => {
                                    if (await continueRegistrationLogin(res)) return;
                                    for (const key in res) {
                                        if (Object.prototype.hasOwnProperty.call(res, key) && key !== 'url') {
                                            localStorage.setItem(key, key === 'token' ? res[key] : JSON.stringify(res[key]));
                                        }
                                    }
                                    router.push({ name: 'client_dashboard' });
                                })
                                .catch((err) => {
                                    console.error('Auto login failed', err);
                                    const targetRoute = (fromMemberLogin && isNewAuthActive.value) ? 'MemberLogin' : 'Login';
                                    
                                    if (responseData.dashboard) {
                                        router.push({
                                            name: targetRoute,
                                            query: { corporate_id: responseData.corporate_id, dashboard: true, ...(registerRef && { ref: registerRef }) },
                                            state: { register: registerOption.data.data.original[0] }
                                        });
                                    } else {
                                        // Check if running on native platform
                                        if (window.Capacitor?.isNativePlatform()) {
                                            // For native platform, use window.location to ensure proper navigation
                                            const loginUrl = `/login?merchant_id=${member.merchant_id}${registerRef ? `&ref=${registerRef}` : ''}`;
                                            window.location.href = loginUrl;
                                        } else {
                                            router.push({
                                                name: targetRoute,
                                                query: { merchant_id: member.merchant_id, ...(registerRef && { ref: registerRef }) },
                                                state: { register: registerOption.data.data.original[0] }
                                            });
                                        }
                                    }
                                });
                            }
                        }else {
                            const registerRef = localStorage.getItem('register_ref_param');
                            if (registerRef) {
                                localStorage.removeItem('register_ref_param');
                            }
                            const responseData = registerResponse.data.data[0];

                            const fromMemberLogin = localStorage.getItem('member_login_origin');
                            localStorage.removeItem('member_login_origin');
                            const targetRoute = (fromMemberLogin && isNewAuthActive.value) ? 'MemberLogin' : 'Login';
                            
                            if (responseData.dashboard) {
                                router.push({
                                    name: targetRoute,
                                    query: { corporate_id: responseData.id, dashboard: true, ...(registerRef && { ref: registerRef }) },
                                    state: { register: registerOption.data.data.original[0] }
                                });
                            } else {
                                router.push({
                                    name: targetRoute,
                                    query: { merchant_id: member.merchant_id, ...(registerRef && { ref: registerRef }) },
                                    state: { register: registerOption.data.data.original[0] }
                                });
                            }
                        }
                    })
                    .catch(handleRegisterError);
                    
                }).catch((err) => {
                    console.error(err);
                    endSubmit('Unable to load registration settings. Please try again.');
                });
            }
        };

        // Auto-register (no form) when a valid `ref` is present. Profile defaults (title, name, phone)
        // are filled by the backend in MemberDomain::register(). Applies to Email OTP, Google and Apple.
        const formatNow = () => {
            const now = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ` +
                `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
        };

        const redirectToExternalAccess = async (access) => {
            if (!access?.url || !access?.token) {
                throw new Error('URL tujuan merchant tidak tersedia untuk melanjutkan login eksternal.');
            }

            const accessUrl = new URL(access.url);
            if (!['http:', 'https:'].includes(accessUrl.protocol)) {
                throw new Error('URL tujuan merchant tidak valid.');
            }
            accessUrl.searchParams.set('member_token', access.token);

            const response = await fetch(accessUrl.toString());
            const result = await response.json();
            if (!response.ok) {
                throw new Error(result?.error || result?.message || 'URL tujuan merchant menolak login.');
            }
            if (!result?.redirectUrl) {
                throw new Error('URL redirect tidak diterima dari merchant.');
            }

            const redirectUrl = new URL(
                /^https?:\/\//i.test(result.redirectUrl)
                    ? result.redirectUrl
                    : `https://${result.redirectUrl}`
            );
            if (!['http:', 'https:'].includes(redirectUrl.protocol)) {
                throw new Error('URL redirect merchant tidak valid.');
            }

            const redirectData = { ...access };
            delete redirectData.url;
            const redirectParams = {
                username: access.username,
                token: access.token,
                tierId: access.tierId,
                tier_name: access.tier_name,
                tier_icon: access.tier_icon,
                point: access.point,
                voucher: access.voucher,
                media: access.media,
            };
            Object.entries(redirectParams).forEach(([key, value]) => {
                if (value !== null && value !== undefined && value !== '') {
                    redirectUrl.searchParams.set(key, value);
                }
            });

            clearRefContext();
            if (window.opener) {
                window.opener.postMessage(redirectData, redirectUrl.origin);
                window.close();
                return;
            }
            window.location.assign(redirectUrl.toString());
        };

        const continueRegistrationLogin = async (loginResult) => {
            const isExternalRequest = hasValidRef.value
                && !window.Capacitor?.isNativePlatform()
                && Boolean(member.merchant_id);
            if (!isExternalRequest) return false;
            const access = {
                ...loginResult,
                url: loginResult?.url || loginResult?.ecommerce_url,
                username: loginResult?.username || loginResult?.name,
                tierId: loginResult?.tierId ?? loginResult?.tier_id,
            };
            if (access.type !== 'web_temp_access') {
                throw new Error('Akses eksternal merchant tidak dapat dibuat. Silakan coba login kembali.');
            }
            await redirectToExternalAccess(access);
            return true;
        };

        const autoRegister = async () => {
            if (isSubmitting.value) return;

            const isNativeApp = window.Capacitor?.isNativePlatform() === true;
            const isSocial = isSocialRegistration.value;
            const provider = isAppleRegistration.value ? 'apple' : 'google';

            page.cardTitle = 'Auto Register';
            page.isLoading = true;
            startSubmit();

            let registered = false;
            let isExternalRequest = false;
            try {
                const registerOption = await store.dispatch('RegisterOption/read_register_option', member.merchant_id);
                const registerAllowed = registerOption.data.data.original[0] == 1;

                const data = {
                    merchant_id: member.merchant_id,
                    email: member.email,
                    ref: refParam.value,
                    email_verified_at: formatNow(),
                };
                const referral = member.referral_code
                    || new URLSearchParams(window.location.search).get('referral')
                    || localStorage.getItem('campaign_referral_code');
                if (referral) data.referral_code = referral;
                if (isNativeApp) data.platform = 'native';
                if (member.google_registration_token) data.google_registration_token = member.google_registration_token;
                if (member.apple_registration_token) data.apple_registration_token = member.apple_registration_token;
                // Email ownership is proven by OTP and re-verified on the backend.
                if (!isSocial) data.otp = otp.value;

                const res = await store.dispatch('Member/register', { data });
                registered = true;
                localStorage.removeItem('campaign_referral_code');
                localStorage.removeItem('register_ref_param');
                const created = res?.data?.data?.[0] || {};
                isExternalRequest = hasValidRef.value
                    && !isNativeApp
                    && !created.dashboard
                    && Boolean(member.merchant_id);

                // Approval-required register option: account exists but cannot log in yet (same as the form flow).
                if (!registerAllowed) {
                    const fromMemberLogin = localStorage.getItem('member_login_origin');
                    localStorage.removeItem('member_login_origin');
                    const targetRoute = (fromMemberLogin && isNewAuthActive.value) ? 'MemberLogin' : 'Login';
                    endSubmit();
                    page.isLoading = false;
                    const query = created.dashboard
                        ? { corporate_id: created.corporate_id, dashboard: true }
                        : { merchant_id: member.merchant_id };
                    if (hasValidRef.value) query.ref = refParam.value;
                    clearRefContext();
                    await router.push({
                        name: targetRoute,
                        query,
                        state: { register: registerOption.data.data.original[0] }
                    });
                    return;
                }

                if (isSocial && created.auth_token && !isExternalRequest) {
                    await completeSocialSignIn(provider, created.auth_token, created);
                    return;
                }

                // Login as a member so registration ends in the dashboard, not merchant access.
                const loginResult = await store.dispatch('Auth/checkLogin', {
                    email: member.email,
                    merchant_id: isExternalRequest ? member.merchant_id : '',
                    corporate_id: created.dashboard ? created.corporate_id : '',
                    dashboard: created.dashboard ? true : '',
                    otp_login: 'login',
                    ref: refParam.value,
                    autoLogin: !isExternalRequest,
                });

                if (isExternalRequest) {
                    if (loginResult?.type !== 'web_temp_access') {
                        throw new Error('URL tujuan merchant belum dikonfigurasi untuk akses eksternal.');
                    }
                    await redirectToExternalAccess(loginResult);
                    return;
                }

                clearRefContext();
                await router.replace({ name: 'client_dashboard' });
            } catch (err) {
                page.isLoading = false;
                if (!registered) {
                    // Fall back to the regular form so the user can still finish registration.
                    handleRegisterError(err);
                    page.cardTitle = 'Form';
                } else {
                    clearRefContext();
                    endSubmit(isExternalRequest
                        ? (err?.message || 'Akun berhasil dibuat, tetapi akses ke website merchant tidak dapat dilanjutkan.')
                        : 'Your account was created, but we could not continue. Please log in.');
                    page.cardTitle = 'Choose Method';
                }
            }
        };

        const handleAppleSignUpSuccess = async (authData) => {
            try {
                page.isLoading = true;
                const result = authData.data || authData;

                // New Apple user: without `ref` show the form (same as Google); with `ref` auto-register.
                if (result.registration_required) {
                    member.apple_registration_token = result.registration_token;
                    member.email = result.profile?.email || member.email;
                    member.first_name = result.profile?.first_name || member.first_name;
                    member.last_name = result.profile?.last_name || member.last_name;
                    if (hasValidRef.value) {
                        await autoRegister();
                        return;
                    }
                    page.cardTitle = 'Form';
                    return;
                }

                const userData = result.user;
                const token = result.token;
                const tenantDomain = result.tenant_domain;

                if (!token) throw new Error('No token received from backend for Apple registration');
                if (!userData) throw new Error('No user data received from backend for Apple registration');

                await finalizeSocialLogin({ provider: 'apple', token, user: userData, tenantDomain });
            } catch (err) {
                validationError.value = err.message || 'Failed to complete registration with Apple.';
            } finally {
                page.isLoading = false;
            }
        };

        const appleSignUpErrorMessages = {
            'AUTH.APPLE.EMAIL_EXISTS_STANDARD': 'This email is already registered with Email & Password. Please sign in on the Login page.',
            'AUTH.APPLE.EMAIL_EXISTS_GOOGLE': 'This email is already registered with Google. Please sign in using Sign in with Google.',
            'AUTH.APPLE.ACCOUNT_MISMATCH': 'This email is already linked to a different Apple account.',
            'AUTH.LOGIN.FAILED.MEMBER.NOT.YET.ACCEPTED': 'Your account is still pending approval. Please wait for merchant verification.',
            'CANCELED': 'Apple Sign-In failed: Cancelled by user.',
        };

        const handleAppleSignUpError = (error) => {
            const code = error.code || '';
            const msg = error.message || '';
            const lower = (code + ' ' + msg).toLowerCase();

            if (lower.includes('cancel') || lower.includes('1001') || lower.includes('1000')) {
                validationError.value = 'Apple Sign-In failed: Cancelled by user.';
            } else {
                validationError.value = appleSignUpErrorMessages[code] || error.message || 'Apple Sign-Up failed. Please try again.';
            }
        };

        const requestOTP = (data) => {
            validationError.value = '';
            return store.dispatch('Member/request_otp', {data})
                .then((response) => {
                    return response;
                })
                .catch((err) => {
                    validationError.value = err.response.data.error;
                    
                    throw err.response.data.error;
                });
        };

        const startCountdown = () => {
            showCountdown.value = true;
            countdownMinutes.value = 2;
            countdownSeconds.value = 0;

            countdownInterval = setInterval(() => {
                if (countdownSeconds.value > 0) {
                    countdownSeconds.value--;
                } else if (countdownMinutes.value > 0) {
                    countdownMinutes.value--;
                    countdownSeconds.value = 59;
                } else {
                    clearInterval(countdownInterval);
                    showCountdown.value = false;
                    showRefreshButton.value = true;
                }
            }, 1000);
        };

        const load_state = () => {
            const data = { ...member };
            requestOTP(data);
            showRefreshButton.value = false;
            startCountdown();
        };

        onUnmounted(() => {
            clearInterval(countdownInterval);
            clearTimeout(slowSubmitTimer);
        });

        const submitOTP = async () => {
            page.isLoading = true;
            otpError.value = '';
            
            try {
                await store.dispatch('Member/submit_otp', {
                    email: member.email,
                    otp: otp.value
                }).then(() => {
                    // OTP email registration always proceeds to the form so the user
                    // explicitly chooses a password, including external ref flows.
                    page.cardTitle = 'Form';
                }).catch((err) => {
                    otpError.value = err.response.data.error;
                });
            } catch (err) {
                otpError.value = err.response?.data?.error;
            } finally {
                page.isLoading = false;
            }
        };

        const changeEmail = () => {
            page.cardTitle = 'Enter Email';
            nextTick(() => {
                newEmailInput.value.focus();
            });
            clearInterval(countdownInterval);
        };

        const resendOTP = () => {
            const newEmail = newEmailInput.value;
            member.email = newEmail;

            const data = {...member};

            page.cardTitle = 'Enter OTP';
            requestOTP(data);
        }

        const isNextButtonDisabled = computed(() => {
            return !member.email;
        });

        const isRegisterButtonDisabled = computed(() => {
            return !member.title || !member.first_name || !member.last_name
                || (!isSocialRegistration.value && !member.password)
                || !!validationName.value
                || (!isSocialRegistration.value && !!passwordValidationError.value)
                || !!phoneValidationError.value;
        });

        const isPasswordMatch = computed(() => {
            if (member.password !== '' && retypePassword.retypePassword !== '') {
                return member.password === retypePassword.retypePassword;
            }
            return true;
        });

        watch(
            () => member.country,
            () => {
                updatePhoneCode();
            },
            () => {
                isNextButtonDisabled.value = !member.email;
            },
            { deep: true }
        );

        onMounted(async () => {
            await loadCountries();
        });

        const loadCountries = async () => {
            try {
                const response = await store.dispatch('Countries/read');
                countriesData.value = response; // Store full country data
                countries.value = response.map(country => ({ value: country.id, text: country.name }));
                updatePhoneCode();
            } catch (err) {
                console.error(err);
            }
        };

        const updatePhoneCode = () => {
            if (!member.country) {
                unknownCountry.value = true;
                return;
            }

            // Find country data by ID and get phone_code directly
            const country = countriesData.value.find(c => c.id === member.country);

            if (country && country.phone_code) {
                unknownCountry.value = false;
                countryCode.value = `${country.phone_code} `;
            } else {
                unknownCountry.value = true;
                console.error(`Phone code not found for country ID: ${member.country}`);
            }
        };

        watch(
            () => [member.first_name, member.last_name],
            ([newFirstName, newLastName]) => {
                const nameRegex = /^[a-zA-Z\s]*$/;
                if (newFirstName && !nameRegex.test(newFirstName)) {
                    validationName.value = 'First name should not contain special characters or numbers.';
                } else if (newLastName && !nameRegex.test(newLastName)) {
                    validationName.value = 'Last name should not contain special characters or numbers.';
                } else {
                    validationName.value = '';
                }
            },
            { deep: true }
        );

        watch(() => member.password, (newPassword) => {
            if (newPassword) {
                const hasUpperCase = /[A-Z]/.test(newPassword);
                const hasLowerCase = /[a-z]/.test(newPassword);
                const hasNumber = /[0-9]/.test(newPassword);
                const hasSpecialChar = /[^A-Za-z0-9]/.test(newPassword);
                const isLongEnough = newPassword.length >= 6;

                if (isLongEnough && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar) {
                    passwordValidationError.value = '';
                } else {
                    passwordValidationError.value = 'Password must be 6 characters and include uppercase, lowercase, numbers, and special characters.';
                }
            } else {
                passwordValidationError.value = '';
            }
        });

        watch(() => member.phone, (newPhone) => {
            if (newPhone) {
                if (newPhone.length < 4) {
                    phoneValidationError.value = 'Phone number must be at least 4 digits.';
                } else if (newPhone.length > 15) {
                    phoneValidationError.value = 'Phone number must not exceed 15 digits.';
                } else {
                    phoneValidationError.value = '';
                }
            } else {
                phoneValidationError.value = '';
            }
        });

        // Toast notification dismiss handlers
        const dismissError = () => {
            validationError.value = '';
        };
        const dismissOtpError = () => {
            otpError.value = '';
        };

        // Auto-dismiss error toast after 5 seconds
        watch(validationError, (val) => {
            if (val) {
                setTimeout(() => { validationError.value = ''; }, 5000);
            }
        });
        watch(otpError, (val) => {
            if (val) {
                setTimeout(() => { otpError.value = ''; }, 5000);
            }
        });

        return {
            titles,
            page,
            member,
            otp,
            isRegistered,
            saveEmail,
            saveMember,
            handleAppleSignUpSuccess,
            handleAppleSignUpError,
            refParam,
            isSocialRegistration,
            isAppleRegistration,
            isNativePlatform,
            loginWithGoogle,
            handleGoogleRegistrationSuccess,
            handleGoogleRegistrationError,
            submitOTP,
            otpError,
            validationError,
            dismissError,
            dismissOtpError,
            validation,
            validationName,
            passwordValidationError,
            phoneValidationError,
            load_state,
            showRefreshButton,
            showCountdown,
            countdownMinutes,
            countdownSeconds,
            formattedTime,
            retypePassword,
            validationPassword,
            isNextButtonDisabled,
            isRegisterButtonDisabled,
            isSubmitting,
            isSlowSubmit,
            submitLabel,
            changeEmail,
            resendOTP,
            newEmailInput,
            isPasswordMatch,
            countries,
            countryCode,
            unknownCountry,
            loginBackground,
            corporateLogo,
            currentYear,
            backgroundStyle,
            loginLink,
            showPassword,
            showRetypePassword,
            isIosPlatform,
            isGoogleRegistration,
            chooseEmail,
            backToChooser
        }
    }
}
</script>
<style scoped>
/* Toast Notification */
.toast-notification {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 320px;
    max-width: 480px;
    padding: 14px 18px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.08);
    border-left: 4px solid #DE5B53;
    z-index: 9999;
    font-size: 14px;
}

.toast-notification__icon {
    flex-shrink: 0;
    color: #DE5B53;
    font-size: 18px;
}

.toast-notification__content {
    flex: 1;
    min-width: 0;
}

.toast-notification__message {
    color: #333333;
    font-weight: 500;
    line-height: 1.4;
    word-break: break-word;
}

.toast-notification__close {
    flex-shrink: 0;
    background: none;
    border: none;
    color: #999;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    padding: 0 2px;
    transition: color 0.2s ease;
}

.toast-notification__close:hover {
    color: #333;
}

.toast-transition-enter-active {
    transition: all 0.35s cubic-bezier(0.21, 1.02, 0.73, 1);
}

.toast-transition-leave-active {
    transition: all 0.25s cubic-bezier(0.06, 0.71, 0.55, 1);
}

.toast-transition-enter-from {
    transform: translateX(-50%) translateY(-30px);
    opacity: 0;
}

.toast-transition-leave-to {
    transform: translateX(-50%) translateY(-20px);
    opacity: 0;
}

@media (max-width: 520px) {
    .toast-notification {
        min-width: auto;
        left: 16px;
        right: 16px;
        transform: none;
        max-width: none;
    }
    .toast-transition-enter-from {
        transform: translateY(-30px);
    }
    .toast-transition-leave-to {
        transform: translateY(-20px);
    }
}

.otp-input {
    width: 100%;
    padding: 0.5rem 0;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: transparent;
    border: none;
    text-align: center;
    border-bottom: 2px solid #ced4da;
    transition: border-color 0.3s ease-in-out;
}
.otp-input:focus {
    outline: none;
    border-bottom-color: #f27178;
}
.otp-input::placeholder {
    color: #ced4da;
}

/* Glassmorphism additions */
.login-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    width: 100%;
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 20px 16px;
}
.login-wrapper::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
}
.glass-login-card {
    background: #ffffff;
    border-radius: 8px;
    padding: 2rem;
    width: 100%;
    max-width: 420px;
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);
    z-index: 1;
    display: flex;
    flex-direction: column;
    margin: auto 0;
}
/* Widen form on register detail step so grid fits perfectly */
.form-detail-card {
    max-width: 600px !important;
    padding: 2.5rem 2rem;
}

.glass-label {
    display: block;
    color: #333333;
    font-size: 13px;
    margin-bottom: 5px;
    font-weight: 500;
}
.glass-input {
    width: 100%;
    background: #f8f9fa;
    border: 1px solid #ced4da;
    color: #333333;
    padding: 10px 12px;
    border-radius: 8px;
    outline: none;
    transition: all 0.3s ease;
}
.glass-input::placeholder {
    color: #6c757d;
}
.glass-input:focus {
    background: #ffffff;
    border-color: #DE5B53;
}
.glass-select option {
    background: #ffffff;
    color: #333333;
}

.custom-input-group {
    position: relative;
    width: 100%;
}
.text-link {
    color: #DE5B53;
    text-decoration: none;
    transition: color 0.3s ease;
}
.text-link:hover {
    color: #c44e47;
}
.login-button {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    background-color: #DE5B53;
    color: white;
    border: none;
    font-weight: 500;
    transition: background-color 0.3s ease;
    cursor: pointer;
}
.login-button:hover {
    background-color: #c44e47;
    transform: none;
}
.login-button:disabled {
    background-color: #a0a0a0;
    cursor: not-allowed;
}
.login-button {
    min-height: 48px; /* comfortable touch target on Android */
}
/* Loading state: keep the brand color so it doesn't look "disabled/broken" */
.login-button.is-loading:disabled {
    background-color: #DE5B53;
    opacity: 0.9;
    cursor: progress;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}
.btn-spinner {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border: 2px solid rgba(255, 255, 255, 0.45);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: btn-spin 0.7s linear infinite;
}
@keyframes btn-spin {
    to { transform: rotate(360deg); }
}
@media (prefers-reduced-motion: reduce) {
    .btn-spinner { animation-duration: 1.6s; }
}
/* Lock the form while submitting (no edits, no accidental taps) */
.form-submitting {
    pointer-events: none;
}
.form-submitting .glass-input {
    opacity: 0.7;
}
.submit-hint {
    margin: 12px 0 0;
    text-align: center;
    font-size: 13px;
    color: #6c757d;
}
.fade-hint-enter-active,
.fade-hint-leave-active {
    transition: opacity 0.3s ease;
}
.fade-hint-enter-from,
.fade-hint-leave-to {
    opacity: 0;
}
.login-footer {
    position: relative;
    margin-top: 20px;
    width: 100%;
    text-align: center;
    color: white;
    z-index: 0;
    font-size: 13px;
    text-shadow: 1px 1px 3px rgba(0,0,0,0.8);
}
.logo-brand {
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.required {
  color: var(--danger-color, #F93E3E);
}
#logo-brand {
    display: grid;
    width: 85%;
    padding-bottom: -10%;
}

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s, box-shadow 5000s ease-in-out 0s !important;
  -webkit-text-fill-color: #333333 !important;
}
input:disabled {
  background-color: #e9ecef !important;
  color: #6c757d !important;
  -webkit-text-fill-color: #6c757d !important;
}

@media (max-width: 576px) {
  .row { flex-direction: column; }
  .row > [class*="col"] { width: 100%; max-width: 100%; padding-left:0 !important; padding-right:0 !important; margin-bottom: 15px; }
  .form-detail-card {
      padding: 1.5rem !important;
  }
}
</style>